import { Link } from 'react-router-dom';
import { Box, Paper, Typography, Button, Grid, Stepper, Step, StepLabel } from '@mui/material';

// 가입 안내 (가입 방법 A·B 설명) — 공개 페이지 (12.01-D011)
const STEPS = ['정보 입력', '계약서 서명', '설치비 입금', 'ACH 자동이체 등록', '기기 배송', '설치', '오픈'];

function SignupGuide() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f6fb', p: 2, pt: { xs: 3, sm: 6 }, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ maxWidth: 820, width: '100%' }}>
        <Typography sx={{ fontSize: { xs: 22, sm: 28 }, fontWeight: 800, color: '#551FFF' }}>Digntec 디지털 사이니지 가입 안내</Typography>
        <Typography color="text.secondary" sx={{ mb: 3 }}>매장 메뉴판·프로모션 화면을 Digntec 이 설치·운영합니다. 가입 방법은 두 가지입니다.</Typography>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2.5, borderRadius: 3, height: '100%' }}>
              <Typography sx={{ fontWeight: 700, mb: 1 }}>① 직접 신청</Typography>
              <Typography variant="body2" sx={{ mb: 2 }}>
                아래 버튼으로 계정과 매장 정보를 입력하면 Digntec 이 확인 후 승인합니다. 신규 매장이면 설치 절차가 시작되고,
                이미 Digntec 을 쓰는 매장이면 기존 매장에 연결됩니다.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                <Button variant="contained" component={Link} to="/register" sx={{ bgcolor: '#551FFF' }}>Google 로 신청</Button>
                <Button variant="outlined" component={Link} to="/register-email">이메일로 신청</Button>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 2.5, borderRadius: 3, height: '100%' }}>
              <Typography sx={{ fontWeight: 700, mb: 1 }}>② Digntec 초대 메일</Typography>
              <Typography variant="body2">
                영업 담당이 매장을 먼저 등록한 경우, <b>"매장 등록 안내"</b> 메일이 갑니다. 메일의 버튼을 눌러 계정과 매장 정보를
                넣으면 <b>승인 없이 바로</b> 매장에 연결됩니다. 링크는 14일 동안 한 번만 쓸 수 있습니다.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        <Paper sx={{ p: 2.5, borderRadius: 3, mb: 3 }}>
          <Typography sx={{ fontWeight: 700, mb: 2 }}>신규 매장 진행 순서</Typography>
          <Box sx={{ overflowX: 'auto', pb: 1 }}>
            <Stepper activeStep={-1} alternativeLabel sx={{ minWidth: 600 }}>
              {STEPS.map((s) => <Step key={s}><StepLabel>{s}</StepLabel></Step>)}
            </Stepper>
          </Box>
          <Typography variant="body2" sx={{ mt: 2 }}>
            계약서는 Digntec 대표 서명이 들어간 상태로 메일로 갑니다. 서명과 함께 <b>설치비</b>를 받고, <b>첫 달 요금부터는 ACH 자동이체</b>로 청구합니다.
            각 단계 메일 하단과 로그인 후 <b>My Store</b> 에서 진행 상황을 볼 수 있습니다.
          </Typography>
        </Paper>

        <Paper sx={{ p: 2.5, borderRadius: 3, mb: 3 }}>
          <Typography sx={{ fontWeight: 700, mb: 1 }}>준비할 것</Typography>
          <Typography variant="body2" component="div">
            <ul style={{ margin: 0, paddingLeft: 18 }}>
              <li>매장 주소·전화, 점주 연락처(이메일·휴대폰)</li>
              <li>설치할 화면(TV) 수와 위치</li>
              <li>ACH 자동이체에 쓸 사업자 은행 계좌</li>
              <li>매장 Wi‑Fi (기기 설치 때)</li>
            </ul>
          </Typography>
        </Paper>

        <Typography variant="body2" color="text.secondary">
          문의: support@digntec.com · (201) 357-7222 · <Link to="/login">로그인</Link>
        </Typography>
      </Box>
    </Box>
  );
}

export default SignupGuide;
